import { Lang } from './i18n/language';

/**
 * Rozmiary plików w języku użytkownika.
 *
 * Dwie rzeczy zależą tu od języka, a wcześniej były zaszyte po polsku:
 * skrót jednostki (francuski pisze „Mo” i „Go”, nie „MB” i „GB”) oraz
 * separator dziesiętny (3,7 MB po polsku i niemiecku, 3.7 MB po angielsku).
 */
const JEDNOSTKI: Record<Lang, { kilo: string; mega: string; giga: string }> = {
    pl: { kilo: 'kB', mega: 'MB', giga: 'GB' },
    en: { kilo: 'kB', mega: 'MB', giga: 'GB' },
    de: { kilo: 'kB', mega: 'MB', giga: 'GB' },
    fr: { kilo: 'ko', mega: 'Mo', giga: 'Go' }
};

/** Bajty → „200 MB”, „1 GB”, „3,7 Mo”. Poniżej megabajta schodzimy na kilobajty. */
export function formatBytes(bytes: string | number | null | undefined, lang: Lang,
    zKilobajtami = false): string {
    const value = Number(bytes ?? 0);
    const jednostki = JEDNOSTKI[lang] ?? JEDNOSTKI.en;

    if (zKilobajtami && value < 1048576) {
        return Math.round(value / 1024).toLocaleString(lang) + ' ' + jednostki.kilo;
    }
    const wGigabajtach = value >= 1073741824;
    const liczba = wGigabajtach ? value / 1073741824 : value / 1048576;

    // maximumFractionDigits obcina zbędne zero: 1,0 GB czyta się gorzej niż 1 GB
    return liczba.toLocaleString(lang, { maximumFractionDigits: 1 })
        + ' ' + (wGigabajtach ? jednostki.giga : jednostki.mega);
}
